import React from "react";

const marts = [
  {
    name: "ValueGrocer",
    logo: (
      <span className="flex items-center gap-2">
        <span className="w-3 h-3 bg-gray-700 rounded-sm opacity-70"></span>
        <span className="font-mono text-gray-700 tracking-tight">
          Value<span className="font-bold">Grocer</span>
        </span>
      </span>
    )
  },
  {
    name: "Premium Foods",
    logo: (
      <span className="flex items-center gap-2">
        <span className="text-yellow-600 text-lg">◎</span>
        <span className="uppercase tracking-[0.18em] font-semibold text-gray-700">
          Premium Foods
        </span>
      </span>
    )
  },
  {
    name: "The Daily Basket",
    logo: (
      <span className="flex items-center gap-2">
        <span className="text-xl">🧺</span>
        <span className="font-semibold text-gray-700">
          The Daily Basket
        </span>
      </span>
    )
  },
  {
    name: "FreshMart",
    logo: (
      <span className="flex items-center gap-1">
        <span className="text-green-500 text-xl">❃</span>
        <span className="font-semibold tracking-wide text-gray-700">
          Fresh<span className="text-green-600 font-bold">Mart</span>
        </span>
      </span>
    )
  }
];

const MartCarousel = () => {
  return (
    <div className="w-full mt-20 overflow-hidden">
      
      {/* Title */}
      <h2 className="text-center text-3xl font-bold text-gray-700 mb-10">
        Trusted Partner Stores
      </h2>

      {/* FULL WIDTH MARQUEE */}
      <div className="relative w-full overflow-hidden">
        <div className="marquee-track">
          {[...marts, ...marts].map((mart, idx) => (
            <div key={idx} className="logo">
              {mart.logo}
            </div>
          ))}
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .marquee-track {
          display: flex;
          gap: 6rem;
          width: max-content;
          animation: marquee 18s linear infinite;
          will-change: transform;
        }

        .logo {
          font-size: 1.6rem;
          opacity: 0.95;
          white-space: nowrap;
          display: flex;
          align-items: center;
        }

        @keyframes marquee {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>
  );
};

export default MartCarousel;
